export default {
  nfcDataSendToAnt: 'NFC Data Send to ANT',
  sendTime: 'Send Time',
  totalLines: 'Total Lines',
  sendPass: 'Send Pass',
  sendFail: 'Send Fail',
  uidSyncData: 'UID sync data',
  syncDate: 'Sync Date',
  nfcDataCneterReceived: 'NFC Data Center Received',
  wmsTaggingData: 'WMS Tagging data',
  date: 'Date',
  plant: 'Plant',
  nfcSentToAnt: 'NFC sent to ANT',
  failed: 'Failed',
  nfcDailyReport: 'NFC Daily Report',
  vendor: 'Vendor'
}
